import { render } from "./EmailCodeConfirm.vue?vue&type=template&id=b2d47a3e&scoped=true"
import script from "./EmailCodeConfirm.vue?vue&type=script&lang=js"
export * from "./EmailCodeConfirm.vue?vue&type=script&lang=js"

import "./EmailCodeConfirm.vue?vue&type=style&index=0&id=b2d47a3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d47a3e"]])

export default __exports__